/**
 * Scores data source for match results
 */

export type MatchStatus = 'final' | 'scheduled'

export interface Match {
  id: string
  day: 1 | 2
  gameNumber: number
  kickoff: string
  venue: string
  venueAddress?: string
  field?: string
  homeTeam: string
  awayTeam: string
  homeScore?: number
  awayScore?: number
  status: MatchStatus
  note?: string
  womens?: boolean
}

export const matches: Match[] = [
  // Day 1 — Saturday, March 28
  {
    id: 'g1',
    day: 1,
    gameNumber: 1,
    kickoff: '9:00 AM',
    venue: 'South High Community School',
    venueAddress: '170 Apricot St, Worcester, MA 01603',
    homeTeam: 'Massachusetts Maritime Academy',
    awayTeam: 'St. Anselm',
    status: 'scheduled',
  },
  {
    id: 'g2',
    day: 1,
    gameNumber: 2,
    kickoff: '10:00 AM',
    venue: 'South High Community School',
    venueAddress: '170 Apricot St, Worcester, MA 01603',
    homeTeam: 'WPI',
    awayTeam: 'WIT',
    status: 'scheduled',
  },
  {
    id: 'g3',
    day: 1,
    gameNumber: 3,
    kickoff: '12:00 PM',
    venue: 'South High Community School',
    venueAddress: '170 Apricot St, Worcester, MA 01603',
    homeTeam: 'WIT',
    awayTeam: 'St. Anselm',
    status: 'scheduled',
  },
  {
    id: 'g4',
    day: 1,
    gameNumber: 4,
    kickoff: '1:00 PM',
    venue: 'South High Community School',
    venueAddress: '170 Apricot St, Worcester, MA 01603',
    homeTeam: 'WPI',
    awayTeam: 'Massachusetts Maritime Academy',
    status: 'scheduled',
  },
  // Day 2 — Sunday, April 12
  {
    id: 'g5',
    day: 2,
    gameNumber: 5,
    kickoff: '11:00 AM',
    venue: 'ICC',
    venueAddress: '200 New Boston Drive, Canton, MA 02021',
    field: 'Field C',
    homeTeam: 'WPI',
    awayTeam: 'St. Anselm',
    status: 'scheduled',
    note: '#3 vs #4 — Placement match',
  },
  {
    id: 'g6',
    day: 2,
    gameNumber: 6,
    kickoff: '1:30 PM',
    venue: 'ICC',
    venueAddress: '200 New Boston Drive, Canton, MA 02021',
    field: 'Field C',
    homeTeam: 'WIT',
    awayTeam: 'Massachusetts Maritime Academy',
    status: 'scheduled',
    note: '#1 vs #2 — Championship match',
  },
  // Women's Showcase — Sunday, April 12 (12:20 PM block)
  {
    id: 'w1',
    day: 2,
    gameNumber: 11,
    kickoff: '12:20 PM',
    venue: 'ICC',
    venueAddress: '200 New Boston Drive, Canton, MA 02021',
    field: 'Field C',
    homeTeam: 'WIT',
    awayTeam: 'North Shore',
    status: 'scheduled',
    womens: true,
  },
  {
    id: 'w2',
    day: 2,
    gameNumber: 12,
    kickoff: '12:20 PM',
    venue: 'ICC',
    venueAddress: '200 New Boston Drive, Canton, MA 02021',
    field: 'Field C',
    homeTeam: 'Providence',
    awayTeam: 'WIT',
    status: 'scheduled',
    womens: true,
  },
  {
    id: 'w3',
    day: 2,
    gameNumber: 13,
    kickoff: '12:20 PM',
    venue: 'ICC',
    venueAddress: '200 New Boston Drive, Canton, MA 02021',
    field: 'Field C',
    homeTeam: 'North Shore',
    awayTeam: 'Providence',
    status: 'scheduled',
    womens: true,
  },
]

/**
 * Get matches for a specific day
 */
export function getMatchesByDay(day: 1 | 2): Match[] {
  return matches.filter(match => match.day === day)
}
